import React from 'react';
import ReactDOM from 'react-dom';
import 'jquery-confirm';
import 'jquery-confirm/dist/jquery-confirm.min.css';
import 'antd/dist/antd.css';
import 'izitoast/dist/css/iziToast.min.css';
import 'aos/dist/aos.css';

import './assets/css/bootstrap.min.css';
import './assets/css/style.min.css';
import './assets/material-design-icons-iconfont/material-design-icons.min.css';
import './assets/icofont/icofont.min.css';
import './assets/css/custom.css';


import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
